export default __webpack_public_path__ + "static/media/user.d0000e97.svg";